import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../assets/img/animation.jpg";
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import navIcon4 from '../assets/images/github.svg';
import { HashLink } from 'react-router-hash-link';
import {
  BrowserRouter as Router
} from "react-router-dom";

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          {/* <Navbar.Brand href="/">
            <img src={logo} alt="Logo" />
          </Navbar.Brand> */}
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
  <Nav.Link
    href="#home"
    className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'}
    onClick={() => onUpdateActiveLink('home')}
  >
    Home
  </Nav.Link>
  <Nav.Link
    href="#education-skill"
    className={activeLink === 'education-skill' ? 'active navbar-link' : 'navbar-link'}
    onClick={() => onUpdateActiveLink('education-skill')}
  >
    Education
  </Nav.Link>
  <Nav.Link
    href="#experience"
    className={activeLink === 'experience' ? 'active navbar-link' : 'navbar-link'}
    onClick={() => onUpdateActiveLink('experience')}
  >
    Experience
  </Nav.Link>
  <Nav.Link
    href="#skills"
    className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'}
    onClick={() => onUpdateActiveLink('skills')}
  >
    Skills
  </Nav.Link>
  <Nav.Link
    href="#projects"
    className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'}
    onClick={() => onUpdateActiveLink('projects')}
  >
    Projects
  </Nav.Link>
  <Nav.Link
    href="https://drive.google.com/file/d/1sSnwDRRALLMzyCMaGk39kA8t3bwB3c4u/view?usp=sharing"
    target="_blank"
    className="navbar-link"
  >
    Resume
  </Nav.Link>
</Nav>

            <span className="navbar-text">
              <div className="social-icon">
                <a href="https://github.com/annuraagggiiit"target="_blank"><img src={navIcon4} alt="Github" /></a>
                <a href="https://www.linkedin.com/in/anuragkhannaiiitm"  target="_blank"><img src={navIcon1} alt="Linkedin" /></a>
                <a href="https://www.instagram.com/annuraaggg"target="_blank"><img src={navIcon3} alt="Instagram" /></a>
              </div>
              <HashLink to='#connect'>
                <button className="vvd"><span>Let’s Connect</span></button>
              </HashLink>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  )
}
